var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_c('div',{attrs:{"id":"sticker-intio-tv"}},[_c('sticker',{attrs:{"img":"intio-tv"}})],1),_vm._v(" "),_c('img',{attrs:{"id":"oldschool-tv","src":require("@/assets/img/oldschool-tv.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }